import armsRum from '@arms/rum-browser';
armsRum.init({ 
			  endpoint: 'https://proj-xtrace-53d544edb79fd7aeaf515b28dbcfcd9-cn-hangzhou.cn-hangzhou.log.aliyuncs.com/rum/web/v2?workspace=default-cms-1481529240680429-cn-hangzhou&service_id=el5p4xy6st@f58d3feed790a4898e674',
			  // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
			  env: process.env.NODE_ENV === 'development'?'local':'prod', 
			  // 设置路由模式， 参考值：'history' | 'hash'
			  spaMode: 'history',
			  collectors: {
			    // 页面性能指标监听开关，默认开启
			    perf: true,
			    // WebVitals指标监听开关，默认开启
			    webVitals: true,
			    // Ajax监听开关，默认开启
			    api: true,
			    // 静态资源开关，默认开启
			    staticResource: true,
			    // JS错误监听开关，默认开启
			    jsError: true,
			    // 控制台错误监听开关，默认开启
			    consoleError: true,
			    // 用户行为监听开关，默认开启
			    action: true,
			  },
			  // 链路追踪配置开关，默认关闭
			  tracing: false,
			});

export default armsRum;